/**
 * HALEY FIRMNESS INDICATOR — 硬度感知
 * Animation Logic
 */
(function() {
  'use strict';

  // --- Reveal Animation on Scroll ---
  function initReveal() {
    var sections = document.querySelectorAll('[data-hf-reveal]');
    if (!sections.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hf-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    sections.forEach(function(section) {
      observer.observe(section);
    });
  }

  // --- Bar Fill Animation ---
  function initBars() {
    var bars = document.querySelectorAll('[data-hf-bar]');
    if (!bars.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var pct = entry.target.getAttribute('data-hf-bar');
          setTimeout(function() {
            entry.target.style.width = pct + '%';
          }, 200);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.3
    });

    bars.forEach(function(bar) {
      observer.observe(bar);
    });
  }

  // --- Value Counter Animation ---
  function initCounters() {
    var values = document.querySelectorAll('[data-hf-value]');
    if (!values.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var target = entry.target;
          var finalValue = parseFloat(target.getAttribute('data-hf-value'));
          animateValue(target, 0, finalValue, 800);
          observer.unobserve(target);
        }
      });
    }, {
      threshold: 0.5
    });

    values.forEach(function(value) {
      observer.observe(value);
    });
  }

  function animateValue(element, start, end, duration) {
    var startTime = null;
    var hasDecimal = end % 1 !== 0;
    var maxSpan = element.querySelector('.hf-single-max');
    var maxText = maxSpan ? maxSpan.outerHTML : '';

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = start + (end - start) * eased;

      var displayValue = hasDecimal ? current.toFixed(1) : Math.round(current);
      element.innerHTML = displayValue + maxText;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        element.innerHTML = (hasDecimal ? end.toFixed(1) : end) + maxText;
      }
    }

    requestAnimationFrame(step);
  }

  // --- Initialize ---
  function init() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      document.querySelectorAll('[data-hf-reveal]').forEach(function(el) {
        el.classList.add('hf-visible');
      });
      document.querySelectorAll('[data-hf-bar]').forEach(function(bar) {
        bar.style.width = bar.getAttribute('data-hf-bar') + '%';
      });
    } else {
      initReveal();
      initBars();
      initCounters();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
